import {ICompany} from "../../../index";
import {ErrorObject} from "../../../error/ErrorObject";

type ICompanyMutable = {
    [K in keyof ICompany]: KnockoutObservable<any>
}

type ICompanyError = {
    [K in keyof Partial<ICompany>]: ErrorObject
}
